'use client';

import dynamic from 'next/dynamic';
import { Suspense } from 'react';

import { Loading } from '@nextui-org/react';

import { icons } from '@/src/utils/icon';
import { Icons } from '@/src/types/icon';

const SVG = dynamic(() => import('react-inlinesvg'), {
  loading: () => <Loading />,
});

interface IconProps {
  icon: Icons | string;
  width?: number;
  height?: number;
  onClick?: (event?: any) => void;
  fill?: string;
}

const Icon: React.FC<IconProps> = ({
  icon,
  width,
  height,
  onClick = () => {},
  fill,
  ...rest
}) => {
  return (
    <Suspense fallback={<Loading />}>
      <SVG
        onClick={(event) => onClick && onClick(event)}
        src={icons[icon]}
        width={width}
        height={height}
        cacheRequests={true}
        loader={<Loading />}
        fill={fill}
        aria-label={`Icon for ${icon}`}
        {...rest}
      />
    </Suspense>
  );
};

export default Icon;
